import { Box, BoxGrid, BoxTitle, BoxValue, IconContainer } from "Pricing/Styles";
import { useEffect, useState } from "react";
import Kycicon1 from "../../Assets/kycicon1.png";
import Kycicon2 from "../../Assets/kycicon2.png";
import { useHistory } from "react-router-dom";
import { storeToLocalStorage } from 'shared/utils/authToken';

type Props={
    application: string;
    totalLocal: number;
    totalIntl: number;
    setPinBox: Function; 
}


const BoxButton=({application, totalLocal, totalIntl, setPinBox}: Props)=>{
    const buttons=[
        {
            title: 'Local Pricing',
            app: 'Gateway',
            id: 1
        },
        {
            title: 'International Pricing',
            app: 'Gateway',
            id: 2
        },
        {
            title: 'Pricing Plan',
            app: 'Agency Banking',
            id: 1
        }
    ]
    const [pinBox, setPinBoxes] = useState(1);
    const [boxes, setBoxes] = useState([]);

    const history = useHistory();

    useEffect(()=>{
        const menu: any=buttons.filter(item=>item.app == application);
        if(menu){
            setBoxes(menu);
        }
        storeToLocalStorage("application", application)
    }, [application])
    return(
        <BoxGrid>
            {
                boxes instanceof Array && boxes.map((items: any)=>{
                    return(
                        <Box
                            key={items.id}
                            isActive={pinBox === items.id ? true : false}
                            onClick={() => {
                                setPinBox(items.id);
                                setPinBoxes(items.id);
                            }}
                            >
                            <IconContainer isActive={true}>
                                <img src={pinBox === items.id ? Kycicon2 : Kycicon1} alt="" />
                            </IconContainer>
                            <BoxTitle>{items.title}</BoxTitle>
                            <BoxValue>{totalLocal}</BoxValue>
                        </Box>
                    )
                })
            }

            <Box
              key={3}
              isActive={pinBox === 3 ? true : false}
              onClick={() => {
                history.push("/pricing/add-new")
              }}
            >
              <IconContainer isActive={true}>
                <img src={pinBox === 3 ? Kycicon2 : Kycicon1} alt="" />
              </IconContainer>
              <BoxTitle>Add plan</BoxTitle>
              <br />
              {/* <BoxValue>0</BoxValue> */}
            </Box>
        </BoxGrid>
    )
}

export default BoxButton;